import { ReactComponent as DOCUMENT } from "../../assets/Document.svg"
import { ReactComponent as DOWNLOAD } from "../../assets/DownloadICON.svg"
import { ReactComponent as EYE } from "../../assets/EyeICON.svg"
import { ReactComponent as DELETE } from "../../assets/DeleteICON.svg"
import BasePopover from "./BasePopover"
import { Delete, Download, Eye, Trash } from "lucide-react"
import { Authorized } from "../authentication/Authorized"
import { TPermission } from "../../auth/permissions"

type BaseDocElementType = {
    label: string
    sublabel?: string
    obv?: boolean
    permissions?: TPermission[]
    onPreview?: () => void
    onDownload?: () => void
    onDelete?: () => void
}

export default function BaseDocElement(props: BaseDocElementType) {
    return (
        <div className="p-3 rounded-default flex flex-row items-center justify-between bg-white border shadow-lg">
            <div className="flex items-center gap-4">
                <DOCUMENT className="w-6 h-6" />
                <p className="font-semibold">
                    {props.label}
                    <span className="text-xs text-gray-400 pl-3">{props.sublabel}</span>
                </p>
            </div>
            <div className="flex gap-4 items-center">
                {props.onDownload && <Download strokeWidth={2} className="w-5 h-5 cursor-pointer" onClick={props.onDownload} />}
                {props.label?.endsWith(".pdf") && props.onPreview && (
                    <Eye onClick={props.onPreview} className="w-5 h-5 cursor-pointer" />
                )}
                {!props.obv && (
                    <Authorized allOf={props.permissions ?? []}>
                        {props.onDelete && (
                            <BasePopover label={"Wirklich löschen?"} placement="topLeft" okButtonClick={props.onDelete}>
                                <Trash strokeWidth={2} className="w-5 h-5 cursor-pointer" />
                            </BasePopover>
                        )}
                    </Authorized>
                )}
            </div>
        </div>
    )
}
